import css from "../../css/listing/snapshot.module.css";

import React from "react";
import PropTypes from "prop-types";
import moneyFormatter from "../../helper/moneyFormatter";
import { OPTIONAL_NUMERIC_FIELDS } from "../../service/listing";

const Details = (props) => {
    const { listing } = props;

    const pairwise = (arr, func) => {
        let r = [];

        for (let i = 0; i < arr.length - 2; i += 2) {
            r.push(
                <div className={css.row} key={"number-" + i}>
                    {arr[i]}
                    {arr[i + 1]}
                </div>
            );
        }

        return r;
    };

    let value,
        details = [];

    for (let f of OPTIONAL_NUMERIC_FIELDS) {
        value = listing[f.name];

        if (value === null || value === "") {
            value = "-";
        } else {
            if (f.label.toLowerCase().includes("price")) {
                value = moneyFormatter(2).format(value);
            } else {
                value = value.toLocaleString();
            }
        }

        details.push(
            <div className={css.column} key={"details_" + f.name}>
                <div className={css.label}>{f.label}</div>
                <div className={css.value}>
                    <strong>{value}</strong>
                </div>
            </div>
        );
    }

    return <div className={css.snapshot}>{pairwise(details)}</div>;
};

Details.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default Details;
